import queryString from 'query-string'
import { types, IRouterPushAction, IRouterClearAction } from '../types/router'

export const push = (
  pathToRedirect: string,
  search: any = null
): IRouterPushAction => ({
  type: types.ROUTER_PUSH,
  pathToRedirect: !!search
    ? `${pathToRedirect}?${queryString.stringify(search)}`
    : pathToRedirect,
})

export const cleanRouter = (): IRouterClearAction => ({
  type: types.ROUTER_CLEAR,
})
